import React, { memo } from 'react';
import { FormControlLabel, makeStyles, Radio, RadioGroup, useRadioGroup } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import clsx from 'clsx';
import { usePayment } from '../../hooks';
import { PAYMENT_CHANNEL } from '../../../../constant/invoice';

const PaymentChannels = () => {
  const { setPaymentChannel, paymentChannel } = usePayment();
  const t = useTranslate();

  return (
    <RadioGroup value={paymentChannel} onChange={(e) => setPaymentChannel(e.target.value)}>
      {Object.values(PAYMENT_CHANNEL).map((item) => (
        <CustomFormControlLabel value={item} label={t(`common.paymentChannel.${item}`)} control={<Radio />} />
      ))}
    </RadioGroup>
  );
};

export default memo(PaymentChannels);

function CustomFormControlLabel(props) {
  const classes = useStyles();
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <FormControlLabel checked={checked} className={clsx(classes.label, checked && classes.checked)} {...props} />;
}

const useStyles = makeStyles((theme) => ({
  label: {
    marginLeft: 0,
    marginRight: 0,
    padding: '4px 8px',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 10,
    marginBottom: 8,
    "&>*[class*='checked']": {
      color: theme.palette.primary.main,
    },
  },
  checked: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
